<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  bodyClass?: HTMLAttributes['class']
  headerClass?: HTMLAttributes['class']
  footerClass?: HTMLAttributes['class']
}>()

const slots = useSlots()
</script>

<template>
  <div
    :class="
      cn(
        ' rounded-2xl bg-background dark:bg-surface-container border-outline-variant shadow-[0_-1px_6px_-1px_rgba(0,0,0,0.1),0_1px_3px_0_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]',
        {
          'divide-y divide-outline-variant': slots.header || slots.footer,
          'p-5': !(slots.header || slots.footer)
        },
        props.class
      )
    "
  >
    <div v-if="slots.header" :class="cn('px-5 py-4', props.headerClass)">
      <slot name="header" />
    </div>
    <div
      :class="
        cn(
          {
            'p-5': slots.header || slots.footer
          },
          props.bodyClass
        )
      "
    >
      <slot />
    </div>
    <div v-if="slots.footer" :class="cn('px-5 py-4', props.footerClass)">
      <slot name="footer" />
    </div>
  </div>
</template>
